import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { LargeTag } from '@/components/ui/Tag/LargeTag';
import { LargeTagOutline } from '@/components/ui/Tag/LargeTagOutline';
import { TagGroup } from '@/components/ui/Tag/TagGroup';
import { SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME, SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED, } from '@/utils/constants/seminar/seminarInformation/adjustSchedule';
import { SEMINAR_INFORMATION_PARTICIPATION_FEES } from '@/utils/constants/seminar/seminarInformation/participationFee';
import { SEMINAR_PARTICIPATION_TYPE_TYPES } from '@/utils/constants/seminar/seminarParticipationType/type';
/**
 * セミナー情報のタグ表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliTagGroup = (props) => {
    const { adjustSchedule, applicationDeadline, categories, className = '', filterCategoryId, isApplicationDeadlineExceeded, participationFee: propParticipationFee, participationTypes: propParticipationTypes, } = props;
    // 随時開催か
    const isAnytime = adjustSchedule === SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME.value;
    // 開催日時が設定されているか
    const isFixed = adjustSchedule === SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED.value;
    // カテゴリ名
    const categoryName = useMemo(() => {
        const category = categories.find(({ id }) => id === filterCategoryId) || categories[0];
        return (category === null || category === void 0 ? void 0 : category.name) || '';
    }, [categories, filterCategoryId]);
    // 参加形態
    const participationTypes = useMemo(() => SEMINAR_PARTICIPATION_TYPE_TYPES.filter((v) => propParticipationTypes.includes(v.value)), [propParticipationTypes]);
    // 参加費用
    const participationFee = useMemo(() => {
        const { label } = SEMINAR_INFORMATION_PARTICIPATION_FEES.find((v) => v.value === propParticipationFee) || {};
        return label;
    }, [propParticipationFee]);
    return (_jsxs(TagGroup, Object.assign({ className: clsx(className) }, { children: [categoryName && (_jsx(LargeTag, Object.assign({ className: 'whitespace-nowrap', color: 'primary' }, { children: categoryName }))), (isAnytime ||
                (isFixed && applicationDeadline && !isApplicationDeadlineExceeded)) && (_jsx(LargeTagOutline, Object.assign({ className: 'whitespace-nowrap' }, { children: "\u53D7\u4ED8\u4E2D" }))), isFixed && applicationDeadline && isApplicationDeadlineExceeded && (_jsx(LargeTag, Object.assign({ className: 'whitespace-nowrap', color: 'discreet' }, { children: "\u53D7\u4ED8\u7D42\u4E86" }))), participationTypes.map((participationType) => (_jsx(LargeTagOutline, Object.assign({ className: 'whitespace-nowrap' }, { children: participationType.label }), participationType.value))), participationFee && (_jsx(LargeTagOutline, Object.assign({ className: 'whitespace-nowrap' }, { children: participationFee })))] })));
};
